import "./page_tittle.scss"

const PageTittle = (props) => {
    return <div className="page_tittle">
        <h1> {props.children} </h1>
    </div>
}


export default PageTittle;